import { useEffect } from "react";

import { useHistory } from "react-router-dom";

import { useApi } from "../../hooks/useApi";

export default function useMeetingInitialization({ inMeetingDetailsRoute, meetingDetailsRouteMatch, store, nonIdSubPaths }) {
  const { getMeetingDetails } = useApi();
  const history = useHistory();
  const params = meetingDetailsRouteMatch?.params;

  useEffect(() => {
    if (!!store.meeting && !store.isJoined) {
      console.log("clear data since prev data is present");
      store.reset();
      store.clearPersistedData();
    }
  }, []);

  useEffect(() => {
    if (meetingDetailsRouteMatch && store.meeting === null) {
      // eslint-disable-next-line eqeqeq
      if (params?.meetingId == store.meeting?.mid) {
        if (!store.isJoined) {
          console.error(
            new Error(
              "IMPLEMENTATION ERROR: we are returning to the meeting page with the meeting data present, but we are not joined! we should reset the meeting data first.",
            ),
          );
        }
      } else if (store.isJoined) {
        console.error(
          new Error(
            "IMPLEMENTATION ERROR: we are opening a meeting page for the first time, but we are already joined in another one! we should leave that first.",
          ),
        );
      }

      // TODO:
      //  to fix issue when on leave and redirect to the /live the fetchMeetingDetails runs again and loads data for the 1st
      //  (or prev meeting) before redirect to /live because still exists on the meeting page which means the params?.meetingId is exist

      const fetchMeetingDetails = async () => {
        if (!inMeetingDetailsRoute) return;
        if (!params?.meetingId || nonIdSubPaths.includes(params?.meetingId)) return;
        await store.fetchMeetingDetails(params?.meetingId, getMeetingDetails);
      };

      if (history.location.pathname === "/live") return;
      fetchMeetingDetails();
    }
  }, [meetingDetailsRouteMatch, store.isJoining, store.userMediaPermissionsGranted, store.meeting]);
}
